import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccepted = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 15,
				height: 15,
				rx: 7.5,
				fill: "#187F16"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 15,
				height: 15,
				rx: 7.5,
				stroke: "#187F16"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M13.3332 4L5.99984 11.3333L2.6665 8",
				stroke: "#F5F9FA",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgAccepted;
